import React from 'react';
export function ProblemSection() {
  return <section className="py-24 bg-stone-900 text-stone-50" data-id="element-159">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-160">
        {/* The Hook */}
        <div className="mb-20 text-center" data-id="element-161">
          <p className="text-forest-300 font-serif italic text-2xl md:text-3xl mb-8 leading-relaxed" data-id="element-162">
            "It’s 11:00 PM. You have a wedding, a high-stakes presentation, or a
            long-awaited date in exactly 48 hours."
          </p>
          <p className="text-lg md:text-xl text-stone-300 leading-relaxed mb-6" data-id="element-163">
            You try on your clothes, but the mirror doesn't lie: you feel heavy,
            your stomach is tight, and that sudden "inflation" makes you want to
            cancel everything.
          </p>
          <p className="text-lg md:text-xl text-stone-300 leading-relaxed font-medium" data-id="element-164">
            You don't have 30 days for a lifestyle overhaul. You have two days
            to stop the bloat and feel like yourself again.
          </p>
        </div>

        {/* The Specific Problem */}
        <div className="bg-stone-800 p-8 md:p-12 rounded-2xl border border-stone-700 relative overflow-hidden" data-id="element-165">
          <div className="absolute top-0 left-0 w-2 h-full bg-forest-500" data-id="element-166"></div>
          <h2 className="text-3xl md:text-4xl font-serif mb-6 text-white" data-id="element-167">
            The "Digestive Traffic Jam"
          </h2>
          <div className="space-y-6 text-lg text-stone-300 leading-relaxed" data-id="element-168">
            <p data-id="element-169">
              Most people think bloating is just "gas." It’s actually a{' '}
              <strong className="text-white font-medium" data-id="element-170">
                Digestive Traffic Jam
              </strong>
              .
            </p>
            <p data-id="element-171">
              When your gut gets overwhelmed by salt, stress, and hidden
              inflammatory additives, it holds onto{' '}
              <strong data-id="element-172">3-5 lbs of toxic water weight</strong> as a defense
              mechanism.
            </p>
            <p data-id="element-173">
              This creates that "distended" look that no amount of morning
              coffee can fix. You feel sluggish, your skin looks dull, and your
              confidence is at an all-time low right when you need it most.
            </p>
          </div>
        </div>
      </div>
    </section>;
}